import { keepPreviousData, useMutation, useQuery } from '@tanstack/react-query';

import { AxiosError, AxiosResponse } from 'axios';

import { CommonResType } from '@/types/commonApiType';

import { api } from '.';

type GetPayInfoParamsType = {
	page: number;
	row?: number;
};
type GetPayInfoDataype = {
	pay_info_goods_name: string;
	pay_info_tran_date: string;
	pay_info_pk: number;
	pay_info_pay_method: string;
};
type GetPayInfoResType = {
	register_info: GetPayInfoDataype[];
	total_count: number;
};
export const useGetRegisterInfoApi = (params: GetPayInfoParamsType) => {
	const url = '/front/getRegisterInfo';
	return useQuery<AxiosResponse, AxiosError, GetPayInfoResType>({
		queryKey: [url, params],
		queryFn: () => api.get(url, params),
		select: (res) => res.data.data,
		placeholderData: keepPreviousData,
	});
};
type GetAbstractListParamsType = { conference_name: string; page: number; row?: number };
type GetAbstractListDataType = {
	abstract_conference_name: string;
	abstract_enrollment_date: string;
	abstract_presentation: string;
	abstract_approve: string;
	abstract_division: string;
	file_path: string;
};
type GetAbstractListResType = {
	abstract: GetAbstractListDataType[];
	total_count: number;
};
export const useGetAbstractListApi = (params: GetAbstractListParamsType) => {
	const url = '/front/getAbstractList';
	return useQuery<AxiosResponse, AxiosError, GetAbstractListResType>({
		queryKey: [url, params],
		queryFn: () => api.get(url, params),
		select: (res) => res.data.data,
		placeholderData: keepPreviousData,
	});
};
export const usePostUploadConferenceAbstractApi = () => {
	const url = '/front/uploadConferenceAbstract';
	return useMutation<AxiosResponse<CommonResType>, AxiosError, FormData>({
		mutationFn: (data: FormData) => api.post(url, data),
		onError: (error) => {
			console.error('Payment approval error:', error);
		},
	});
};
type GetPastConferencesParamsType = { page: number; row?: number };
export type GetPastConferencesDataType = {
	admin_name: string;
	member_name: string;
	guide_enrollment_date: string;
	guide_hit: number;
	guide_pk: string;
	guide_title: string;
	file_path: string | null;
};
type GetPastConferencesResType = {
	conferences: GetPastConferencesDataType[];
	total_count: number;
};

export const useGetPastConferencesApi = (params: GetPastConferencesParamsType) => {
	const url = '/front/getPastConferences';
	return useQuery<AxiosResponse, AxiosError, GetPastConferencesResType>({
		queryKey: [url, params],
		queryFn: () => api.get(url, params),
		select: (res) => res.data.data,
	});
};

type GetConferenceDetailParamsType = { guide_pk: number | string };
export type GetConferenceDetailDataType = {
	admin_name: string;
	admin_pk: number;
	file_pk: number;
	guide_content: string;
	guide_delete_yn: number;
	guide_enrollment_date: string;
	guide_exposure_yn: string;
	guide_hit: number;
	guide_image_url: string;
	guide_pk: number;
	guide_title: string;
	guide_update_date: string;
	guide_video_url: string;
	file: GetConferenceDetailFileType[];
};
type GetConferenceDetailFileType = {
	file_original_name: string;
	file_path: string;
	file_pk: number;
	file_size: number;
};
type GetConferenceDetailResType = {
	conferences: GetConferenceDetailDataType;
	next_pk: number;
	prev_pk: number;
};
export const useGetConferenceDetailApi = (params: GetConferenceDetailParamsType) => {
	const url = '/front/getPastConferencesDetail';
	return useQuery<AxiosResponse, AxiosError, GetConferenceDetailResType>({
		queryKey: [url, params],
		queryFn: () => api.get(url, params),
		select: (res) => res.data.data,
		placeholderData: keepPreviousData,
		enabled: false,
	});
};
